import * as React from 'react';

import {
  Box,
  Button,
  Chip,
  Card,
  Typography,
  IconButton,
  Divider,
  Menu,
  MenuItem
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'
import { Draggable } from '@hello-pangea/dnd';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';

import SlideModal from '../../modals/SlideModal';
import QueryModal from '../../modals/QueryModal';
import DetailModal from '../../modals/DetailModal';
import PreviewModal from '../../modals/PreviewModal';
import AxisModal from '../../modals/AxisModal';

import { deleteSlide } from '../../slices/presentation';

export default function PageCard(props) {
  const { id, pId, index, title, source, prompt, query, comment, isComment, data, visualization, chart, x_column, y_column } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openSlide, setOpenSlide] = React.useState(false);
  const [openQuery, setOpenQuery] = React.useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);
  const [detailType, setDetailType] = React.useState(null);
  const [detail, setDetail] = React.useState(null);
  const [openPreview, setOpenPreview] = React.useState(false);
  const [openAxis, setOpenAxis] = React.useState(false);
  const [currentXColumn, setCurrentXColumn] = React.useState(x_column);
  const [currentYColumn, setCurrentYColumn] = React.useState(y_column);

  const dispatch = useDispatch();

  const handleCloseSetting = () => {
    setAnchorEl(null)
  }

  const handleComment = (e) => {
    setOpenDetail(true);
    setDetailType('comment');
    setDetail(comment);
  }

  const handleData = (e) =>{
    setOpenDetail(true);
    setDetailType('table');
    setDetail(data);
  }

  const handleEdit = (e) => {
    setOpenSlide(true);
  }

  const handleRemove = (e) => {
    dispatch(deleteSlide({id: pId, index}));
  }

  const handleCloseQuery = (e) => {
    setOpenQuery(false);
  }

  const handleCloseDetail = (e) => {
    setOpenDetail(false);
  }

  const handleCloseSlide = (e) => {
    setOpenSlide(false);
  }

  return (
    <Draggable key={id} draggableId={String(id)} index={index}>  
      {(provided) => (  
        <div   
          ref={provided.innerRef}   
          {...provided.dragHandleProps}
          {...provided.draggableProps}
        >  
          <Box sx={{ marginBottom: 2 }}>  
            <Card sx={{ boxShadow: 'rgba(145, 158, 171, 0.3) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px' }}>  
              <Box className="flex flex-row align-center" sx={{ marginX: 2, marginY: 1 }}>  
                <Typography sx={{ flexGrow: 1, fontSize: 14 }}>{title}</Typography>  
                <IconButton 
                  sx={{ flexGrow: 0 }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >  
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </Box>  
              <Box sx={{ marginX: 2, marginY: 1 }}>  
                <Typography sx={{ fontSize: 12 }}>  
                {prompt}
                </Typography>  
              </Box>  
              <Box className='flex flex-row align-center' sx={{ marginX: 2, marginY: 1 }}>  
                <StorageRoundedIcon fontSize="small" />  
                <Typography sx={{ flexGrow: 1, fontSize: 12, marginLeft: 1 }}>{source}</Typography>  
                <Chip label="Mobile" size="small" sx={{ flexGrow: 0, borderRadius: 2, background: 'rgb(93, 135, 255)', color: 'white', fontSize: 12 }} />  
              </Box>  
            </Card>  
          </Box>  
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseSetting}
            onClick={handleCloseSetting}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '& .MuiList-root': {
                  py: '4px'
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  left: 12,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          >
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={() => setOpenPreview(true)}>
              Preview
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={() => setOpenAxis(true)}>
              Edit Axes
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={() => setOpenQuery(true)}>
              View Query
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleComment}>
              View Comment
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleData}>
              View Data
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleEdit}>
              Edit
            </MenuItem>
            <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleRemove}>
              Remove
            </MenuItem>
          </Menu>
          <SlideModal
            open={openSlide}
            pId={pId}
            defaultTitle={title}
            defaultPrompt={prompt} 
            defaultVisualization={visualization}
            defaultDatabase={source}
            defaultComment={isComment}
            index={index}
            updateMode={true}
            handleClose={handleCloseSlide}
          />
          <QueryModal
            open={openQuery}
            query={query}
            handleClose={handleCloseQuery}
          />
          <DetailModal
            open={openDetail}
            type={detailType}
            data={detail}
            handleClose={handleCloseDetail}
            handleSave={handleCloseDetail}
          />
          <PreviewModal
            open={openPreview}
            title={title}
            data={data}
            visualization={visualization}
            chart={chart}
            x_column={currentXColumn}
            y_column={currentYColumn}
            handleClose={() => setOpenPreview(false)}
          />
          <AxisModal
            open={openAxis}
            pId={pId}
            index={index}
            data={data}
            x_column={currentXColumn}
            y_column={currentYColumn}
            handleClose={() => setOpenAxis(false)}
            onSave={(xCol, yCol) => { setCurrentXColumn(xCol); setCurrentYColumn(yCol); }}
          />
        </div>  
      )}  
    </Draggable>  
  )
}